import Splide from '@splidejs/splide';

/**
 * Trigger a click event on the post-title url when clicking on the tile
 * Add a button to the post-image
 */
(() => {
  document.querySelectorAll('.bloglatestposts_container .blog-posts-grid-view .tile')
    .forEach((tile) => {
      const postTitle = tile.querySelector('.post-title a');
      if (!postTitle) return;
      tile.addEventListener('click', () => {
        postTitle.click();
      });

      const postImage = tile.querySelector('.post-image');
      if (!postImage) return;
      const button = document.createElement('button');
      button.classList.add('btn-custom', 'secondary');
      button.textContent = 'Read More';
      postImage.appendChild(button);
    });
})();

/**
 * Transform the blog-posts-grid into a splide slider
 * Add a subtitle
 */
(() => {
  document.querySelectorAll('.bloglatestposts_container')
    .forEach((blogPostsWidget) => {
      const blogPostsGrid = blogPostsWidget.querySelector('.blog-posts-grid');
      blogPostsGrid.classList.add('splide', 'splide__dark');

      // Add a subtitle
      const subtitle = document.createElement('p');
      subtitle.textContent = 'Insights and updates';
      blogPostsGrid.appendChild(subtitle);

      // Add a button
      const viewAllButton = document.createElement('a');
      viewAllButton.setAttribute('href', '/blog?display_mode=list');
      viewAllButton.classList.add('btn-custom', 'primary', 'view-all-posts');
      viewAllButton.textContent = 'View All Posts';
      blogPostsGrid.appendChild(viewAllButton);

      const row = blogPostsGrid.querySelector(':scope > .row');
      row.classList.add('splide__track');

      const blogPostsGridView = row.querySelector('.blog-posts-grid-view');
      blogPostsGridView.classList.add('splide__list');

      const tiles = blogPostsGridView.querySelectorAll('.blog-post');
      tiles.forEach((tile) => {
        tile.classList.add('splide__slide');
      });
    });
})();

/**
 * Slider settings
 */
(() => {
  document.querySelectorAll('.bloglatestposts_container .splide')
    .forEach((item) => {
      const cardAmount = item.querySelectorAll('.splide__slide').length;

      const slider = new Splide(item, {
        type: 'loop', // 'slide', 'loop' or 'fade'
        rewind: true, // go back to the first slide after the last
        perPage: 3, // how many items to show
        perMove: 1, // how many items to show when clicking next/prev
        gap: 0, // space between items
        pagination: cardAmount > 3,
        arrows: false,
        autoplay: false, // turn it on
        interval: 5000, // time between slides
        drag: cardAmount > 3, // disable drag if all slides are visible
        breakpoints: {
          768: {
            perPage: 2,
            pagination: cardAmount > 2,
            autoplay: true,
            drag: cardAmount > 2,
          },
          480: {
            perPage: 1,
            pagination: cardAmount > 1,
            autoplay: true,
            drag: cardAmount > 1,
          },
        },
      });
      slider.mount();
    });

  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
  }, 500);
})();
